import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import EmploymentPeriod     from './Sections/EmploymentPeriod';
import SubmitInput          from '../Fields/SubmitInput';
import Field                from '../Field';
import Employer             from './Sections/Employer';
import SelfEmployed         from './Sections/SelfEmployed';
import Independent          from './Sections/Independent';
import Pension              from './Sections/Pension';
import { browserHistory }   from 'react-router';
import FullPageSpinner      from '../Fragments/FullPageSpinner';

let Quote = require('../Managers/Quote.js');
let HttpService = require('../Managers/HttpService');
let envConfig;

class AddFinancialReferee extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
            financialRefereeStatus: 1,
            financialRefereeType: null,
            isEmploymentTemporary: null,
            financialRefereeNumber: null,
            sectionToShow: null,
            isLoading: true
        };
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillMount() {
        window.localStorage.clear();
        let uuidFormat = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if ( ! this.props.params.tokenId || ! uuidFormat.test(this.props.params.tokenId)) {
            // No token = error page
            browserHistory.push('/error/no-auth');
            return false;
        }

        // Set the state of the financialRefereeType so we can save back to IRIS
        if (this.props.params.number) {
            this.setState({
                financialRefereeNumber: parseInt(this.props.params.number)
            });
            if (parseInt(this.props.params.number) === 1) {
                // Cannot 'add' first financial referee = error page
                browserHistory.push('/error/not-found');
                return false;
            }
            this.setState({
                isLoading: false
            });
        } else if (this.props.params.existingNumber) {
            this.setState({ financialRefereeStatus: parseInt(this.props.params.existingNumber) });

            // Existing financial referee, so get the data
            this.getData();
        } else {
            // No token = error page
            browserHistory.push('/error/not-found');
            return false;
        }

        if ((this.props.params.number && this.props.params.number > 3) || (this.props.params.existingNumber && this.props.params.existingNumber > 3)) {
            // No valid financial referee number = error page
            browserHistory.push('/error/not-found');
            return false;
        }

        // Set all the legal texts - inject relevant ones to the footer.
        HttpService.getPrivateLegalTexts(this.props.params.tokenId)
        .then(() => {
            document.getElementById('copyright-notice').innerHTML = Quote.getByPath('domainInfo.copyrightNotice');
        })
        .catch(error => {
            throw error;
        });

        envConfig = HttpService.getConfigForHost();
    }

    componentWillUpdate() {
        this.inputComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
    }

    getChildInputComponents() {
        return this.inputComponents;
    }

    getData() {
        let index = (this.props.params.number ? this.props.params.number : this.props.params.existingNumber);
        HttpService.getRetrieveFinancialReferee(this.props.params.tokenId, index)
        .then(data => {
            window.localStorage.setItem('EmploymentFinancialReferee', JSON.stringify(data));
            this.setState({
                isLoading: false
            });
        });
    }

    saveNewFinancialReferee() {
        this.setState({ isFullPageSpinnerActive: true });
        Quote.setByPath('EmploymentFinancialReferee.financialRefereeStatus', this.props.params.number);
        let inputComponents = [];

        this.childComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        }).map(c => {
            inputComponents = inputComponents.concat(c.getChildInputComponents());
        });

        inputComponents = inputComponents.concat(this.inputComponents).filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents.map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            this.setState({ isFullPageSpinnerActive: false });
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                HttpService.postSaveFinancialReferee(this.props.params.tokenId, this.props.params.number)
                .then(() => {
                    this.setState({ isFullPageSpinnerActive: false });
                    window.location.replace(envConfig.tatLanding.url);
                })
                .catch(() => {
                    this.setState({ isFullPageSpinnerActive: false });
                });
            }
        }, 1000);
    }

    saveExistingFinancialReferee() {
        this.setState({ isFullPageSpinnerActive: true });
        Quote.setByPath('EmploymentFinancialReferee.financialRefereeStatus', this.props.params.existingNumber);
        let inputComponents = [];

        this.childComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        }).map(c => {
            inputComponents = inputComponents.concat(c.getChildInputComponents());
        });

        inputComponents = inputComponents.concat(this.inputComponents).filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents.map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            this.setState({ isFullPageSpinnerActive: false });
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                HttpService.postSaveFinancialReferee(this.props.params.tokenId, this.props.params.existingNumber)
                .then(() => {
                    this.setState({ isFullPageSpinnerActive: false });
                    window.location.replace(envConfig.tatLanding.url);
                })
                .catch(() => {
                    // they're independent means and they've errored - redirect them anyway
                    if (Quote.getByPath('EmploymentFinancialReferee.financialRefereeType') == 5 &&
                        Quote.getByPath('EmploymentFinancialReferee.employmentStatus') == 6) {
                        window.location.replace(envConfig.tatLanding.url);
                    } else {
                        // something unknown bad has happened
                        this.setState({ isFullPageSpinnerActive: false });
                    }
                });
            }
        }, 1000);
    }

    calculateEmploymentTypeFromFinancialRefereeType() {
        const ref = JSON.parse(window.localStorage.getItem('EmploymentFinancialReferee'));
        if (window.uorn(ref)) {
            return null;
        }
        const type = ref.financialRefereeType;

        switch (type) {
            case 2:
                return 1;
            case 4:
                return 4;
            case 6:
            case 1:
            case 5:
                return 2;
        }
    }

    /**
     * Sets a pseudo 'employmentStatus' against this financial referee. If we
     * are adding or editing an existing financial referee, then we save the
     * financialRefereeType when we select which form section we want to show.
     *
     *
     * @param fieldName
     * @param e
     */
    setEmploymentState(fieldName, e) {
        this.setState({ sectionToShow: e });

        // if this is the first financial referee and we're editing, we also
        // need to set the employment status and send that along
        if (!window.uorn(this.props.params.existingNumber) && parseInt(this.props.params.existingNumber) == 1) {
            Quote.setByPath('EmploymentFinancialReferee.employmentStatus', parseInt(e));
        }

        // we only need to update the type if you DONT have an existing number
        // because if you DO have an existing, your financialRefereeType is already
        // set in stone, unless it's the first one...
        if (this.props.params.number || this.props.params.existingNumber == 1) {
            let chunk = 'EmploymentFinancialReferee';
            if (this.state.financialRefereeNumber !== 1 || this.props.params.existingNumber == 1) {
                switch(parseInt(e)) {
                    case 1:
                        Quote.set('financialRefereeType', 2, chunk);
                        break;
                    case 2:
                        Quote.set('financialRefereeType', 1, chunk);
                        break;
                    case 6:
                        Quote.set('financialRefereeType', 5, chunk);
                        break;
                    case 4:
                        Quote.set('financialRefereeType', 4, chunk);
                        break;
                }
            }
        }
    }

    render() {
        let index = parseInt(this.props.params.number ? this.props.params.number : this.props.params.existingNumber);
        return(
            <div>
                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                { this.state.isLoading === true ?
                    <div className="loading">
                        <div className="spinner">
                            <p><strong>Loading...</strong></p>
                            <div className="bounce1" />
                            <div className="bounce2" />
                            <div className="bounce3" />
                        </div>
                    </div>
                :
                <div>
                    <question-row class="header-row">
                        <h2>{this.props.params.existingNumber ? <span>Edit</span> : <span>Add</span>} Financial Referee</h2>
                    </question-row>

                    {this.props.params.existingNumber && parseInt(this.props.params.existingNumber) === 1 ?
                        <div>
                            <Field
                                fieldName="employmentStatus"
                                type="radio-group"
                                question="Employment type"
                                options={[
                                    {
                                        value: 1,
                                        text: 'Employed'
                                    },
                                    {
                                        value: 2,
                                        text: 'Self-employed'
                                    },
                                    {
                                        value: 6,
                                        text: 'I\'m of independent means'
                                    },
                                    {
                                        value: 4,
                                        text: 'In receipt of a pension'
                                    },
                                ]}
                                ref={(instance) => {this.inputComponents.push(instance);}}
                                callbackFunction={this.setEmploymentState.bind(this)}
                                onLoadFunction={(fn, v) => { this.setState({ sectionToShow: v }); }}
                                loadValues={true}
                                overwriteDefaultValue={this.calculateEmploymentTypeFromFinancialRefereeType}
                            />
                            <EmploymentPeriod
                                termLength={this.props.termLength}
                                source={'EmploymentFinancialReferee'}
                            />
                        </div>
                    :
                        <div>
                            <Field
                                fieldName="employmentStatus"
                                type="radio-group"
                                question="Employment type"
                                options={[
                                    {
                                        value: 1,
                                        text: 'Employed'
                                    },
                                    {
                                        value: 2,
                                        text: 'Self-employed'
                                    },
                                    {
                                        value: 4,
                                        text: 'In receipt of a pension'
                                    },
                                ]}
                                ref={(instance) => {this.inputComponents.push(instance);}}
                                callbackFunction={this.setEmploymentState.bind(this)}
                                onLoadFunction={(fn, v) => { this.setState({ sectionToShow: v }); }}
                                loadValues={true}
                                overwriteDefaultValue={this.calculateEmploymentTypeFromFinancialRefereeType}
                            />
                        </div>
                    }

                    {this.state.sectionToShow == 1 ?
                        <Employer
                            productId={parseInt(Quote.get('productId', 'EmploymentFinancialReferee'))}
                            termLength={null}
                            source="EmploymentFinancialReferee"
                            financialRefereeStatus={index}
                            ref={(instance) => {this.childComponents.push(instance);}}
                        />
                    : null}

                    {this.state.sectionToShow == 2 ?
                        <SelfEmployed
                            productId={parseInt(Quote.get('productId', 'EmploymentFinancialReferee'))}
                            termLength={null}
                            source="EmploymentFinancialReferee"
                            financialRefereeStatus={index}
                            ref={(instance) => {this.childComponents.push(instance);}}
                        />
                    : null}

                    {this.state.sectionToShow == 6 ?
                        <Independent
                            productId={parseInt(Quote.get('productId', 'EmploymentFinancialReferee'))}
                            source="EmploymentFinancialReferee"
                            financialRefereeStatus={index}
                            ref={(instance) => {this.childComponents.push(instance);}}
                        />
                    : null}

                    {this.state.sectionToShow == 4 ?
                        <Pension
                            productId={parseInt(Quote.get('productId', 'EmploymentFinancialReferee'))}
                            termLength={null}
                            source="EmploymentFinancialReferee"
                            financialRefereeStatus={index}
                            ref={(instance) => {this.childComponents.push(instance);}}
                        />
                    : null}

                    <SubmitInput
                        label="Save details"
                        callbackFunction={this.props.params.number ? this.saveNewFinancialReferee.bind(this) : this.saveExistingFinancialReferee.bind(this)}
                        backLink={true}
                        backLinkText={"Cancel"}
                        backLinkUrl={envConfig.tatLanding.url}
                        saveForLater={false}
                    />
                </div>
                }
            </div>
        );
    }
}

AddFinancialReferee.propTypes = {
    termLength: PropTypes.number.isRequired,
    params:     PropTypes.object,
};

AddFinancialReferee.defaultProps = {
    termLength: 6,
    financialRefereeStatus: 2,
    isFullPageSpinnerActive: false,
};

export default AddFinancialReferee;


// WEBPACK FOOTER //
// ./src/components/Screens/AddFinancialReferee.js